export default "__VITE_ASSET__IsBSixzv__"